// @ts-nocheck
import { LINK_VIDEO } from "constants/common";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  base64ToFile,
  downloadImage,
  shareImage,
  urlAssetsCustom,
} from "utils/common";
import html2canvas from "html2canvas";
import { UploadFile } from "utils/uploadBlob";

const PopupCard = (props) => {
  const [imgUrl, setImgUrl] = useState(null);
  const downloadRef = useRef();
  const [dataShare, setDataShare] = useState();
  const exportAsImage = async (el, imageFileName) => {
    const canvas = await html2canvas(el);
    const image = canvas.toDataURL("image/png", 1.0);
    const file = base64ToFile(image, "Card.png");
    // let blobsInContainer = await UploadFile(file);
    setDataShare(file);
    setImgUrl(image);
  };
  useEffect(() => {
    exportAsImage(downloadRef.current, "Card");
  }, []);
  return (
    <>
      <div className="popup-overlay modal-card">
        <div className="popup-warp">
          <div className="close-modal" onClick={props.closeModalCard}></div>
          <div ref={downloadRef} className="cardWrapper">
            <div className="content-image">
              <img
                className="logoCard"
                src={urlAssetsCustom("assets/img/logoCard.png")}
              />
              <div className="nameSend">
                <h3>
                  <span> Đến </span>
                  <span>
                    {props?.contentCard?.receiverName || "Gửi mẹ kính yêu"}
                  </span>
                </h3>
              </div>
              {/* <p>{props?.contentCard?.content}</p> */}
              <p
                style={{ whiteSpace: "pre-line" }}
                dangerouslySetInnerHTML={{
                  __html: props?.contentCard?.content,
                }}
              ></p>
              <img
                className="spCard"
                src={urlAssetsCustom("assets/img/sp.png")}
              />
            </div>
            <div className="image-card">
              <img
                src={props?.contentCard?.imageUrl}
                alt={props?.contentCard?.imageUrl}
              />
            </div>
          </div>
          <div className="group-btn-inline">
            <button
              type="button"
              className="btn btn-info btn-block"
              onClick={() => {
                downloadImage(imgUrl, "Card.png");
              }}
            >
              <a>
                <span className="i-download"></span> Tải xuống
              </a>
            </button>
            <button
              type="button"
              className="btn btn-info btn-block"
              onClick={async () => {
                shareImage(dataShare, "Card");
              }}
            >
              <a>
                <span className="i-share"></span> Chia sẻ
              </a>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
export default PopupCard;
